// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZO1dptWwxhLIavfF9h23 {
    max-width: 480px;
}

.vDlyVdwgsmQ669V4Ut5K {
    display: flex;
    flex-direction: column;
    /* Let header/modal, content, and footer stack naturally; content will flex */
    min-height: 100vh;
    background-color: white;
}

.PPBs6U4RLTHWMMdgxv7q {
    flex: 1 1 auto; /* fill remaining space */
    display: flex;
    flex-direction: column;
}

.ryQwsiJGvmlrjuLBWtTg,
.L49RVKmfdE0MoodC8zM7 {
    background-color: #324257;
    color: white;
    padding: 12px 0;
}

.ryQwsiJGvmlrjuLBWtTg {
    margin-bottom: 16px;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 3;
}

.L49RVKmfdE0MoodC8zM7 {
    bottom: 0;
    margin-top: 18px;
    position: sticky;
    width: 100%;
    z-index: 3;
}

.L49RVKmfdE0MoodC8zM7 .ZO1dptWwxhLIavfF9h23 {
    max-width: 100%;
    white-space: nowrap; /* keep help text on one line */
    padding-right: 84px; /* space for wheelchair + equal housing icons */
}

/* Avoid overlap with permanent sidebar footer on desktop */
@media (min-width: 960px) {
    .L49RVKmfdE0MoodC8zM7 {
        padding-left: 310px; /* drawerWidth */
    }
}

.BL4iXhQk2DkQ_qOQpAT0 {
    position: absolute;
    top: 8px;
    right: 44px;
    background: url('https://s3.amazonaws.com/hc-images2/wheelchair-blue.png');
    background-size: 28px;
    height: 28px;
    width: 28px;
    margin-bottom: 8px;
}

.oknLfM0QemRz36LsBNA1 {
    position: absolute;
    top: 8px;
    right: 8px;
    background: url('https://s3.amazonaws.com/hc-images2/EHO-sm.png');
    background-size: 28px;
    height: 28px;
    width: 28px;
    filter: invert(100%);
    margin-bottom: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/eligibility/layout.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6EAA6E;IAC7E,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc,EAAE,yBAAyB;IACzC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,UAAU;AACd;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB,EAAE,+BAA+B;IACpD,mBAAmB,EAAE,+CAA+C;AACxE;;AAEA,2DAA2D;AAC3D;IACI;QACI,mBAAmB,EAAE,gBAAgB;IACzC;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,0EAA0E;IAC1E,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iEAAiE;IACjE,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":[".container {\n    max-width: 480px;\n}\n\n.page {\n    display: flex;\n    flex-direction: column;\n    /* Let header/modal, content, and footer stack naturally; content will flex */\n    min-height: 100vh;\n    background-color: white;\n}\n\n.content {\n    flex: 1 1 auto; /* fill remaining space */\n    display: flex;\n    flex-direction: column;\n}\n\n.header,\n.footer {\n    background-color: #324257;\n    color: white;\n    padding: 12px 0;\n}\n\n.header {\n    margin-bottom: 16px;\n    position: sticky;\n    top: 0;\n    width: 100%;\n    z-index: 3;\n}\n\n.footer {\n    bottom: 0;\n    margin-top: 18px;\n    position: sticky;\n    width: 100%;\n    z-index: 3;\n}\n\n.footer .container {\n    max-width: 100%;\n    white-space: nowrap; /* keep help text on one line */\n    padding-right: 84px; /* space for wheelchair + equal housing icons */\n}\n\n/* Avoid overlap with permanent sidebar footer on desktop */\n@media (min-width: 960px) {\n    .footer {\n        padding-left: 310px; /* drawerWidth */\n    }\n}\n\n.wheelchair {\n    position: absolute;\n    top: 8px;\n    right: 44px;\n    background: url('https://s3.amazonaws.com/hc-images2/wheelchair-blue.png');\n    background-size: 28px;\n    height: 28px;\n    width: 28px;\n    margin-bottom: 8px;\n}\n\n.equalhouse {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background: url('https://s3.amazonaws.com/hc-images2/EHO-sm.png');\n    background-size: 28px;\n    height: 28px;\n    width: 28px;\n    filter: invert(100%);\n    margin-bottom: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ZO1dptWwxhLIavfF9h23`,
	"page": `vDlyVdwgsmQ669V4Ut5K`,
	"content": `PPBs6U4RLTHWMMdgxv7q`,
	"header": `ryQwsiJGvmlrjuLBWtTg`,
	"footer": `L49RVKmfdE0MoodC8zM7`,
	"wheelchair": `BL4iXhQk2DkQ_qOQpAT0`,
	"equalhouse": `oknLfM0QemRz36LsBNA1`
};
export default ___CSS_LOADER_EXPORT___;
